import { useState, useEffect } from 'react';

/**
 * Hook to detect if the user has requested reduced motion.
 * Respects the prefers-reduced-motion media query for accessibility.
 *
 * @returns {boolean} true if user prefers reduced motion, false otherwise
 */
export const useReducedMotion = (): boolean => {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mediaQuery.matches);

    const handleChange = (e: MediaQueryListEvent) => {
      setReducedMotion(e.matches);
    };

    // Store which API we're using to ensure correct cleanup
    const usesModernAPI = typeof mediaQuery.addEventListener === 'function';

    if (usesModernAPI) {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      // @ts-ignore - deprecated API for older browsers
      mediaQuery.addListener(handleChange);
    }

    return () => {
      // Use the same API for cleanup that we used for setup
      if (usesModernAPI) {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        // @ts-ignore - deprecated API for older browsers
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  return reducedMotion;
};
